import { AllSeriesContentBlocks, allSeriesContentBlocks } from 'app/blocks'
import { gql } from 'graphql-request'

export interface AllSeriesPageContent {
  pageContent: AllSeriesContentBlocks[]
}

export const createAllSeriesPageQuery = () => gql`
  ${allSeriesContentBlocks}
  query getAllSeriesPage {
    AllSeriesPage {
      pageContent {
        __typename
        ...trendingSeriesFragment
        ...justUpdatedSeriesFragment
        ...bannerFragment
        ...promoBanner
        ...latestGridFragment
      }
    }
  }
`

export const mapToAllSeriesPageContent = (data: any): AllSeriesPageContent => {
  return {
    pageContent: data.AllSeriesPage.pageContent as AllSeriesContentBlocks[],
  }
}
